import Command from '@ckeditor/ckeditor5-core/src/command';
import first from '@ckeditor/ckeditor5-utils/src/first';
import getAncestors from '@ckeditor/ckeditor5-utils/src/dom/getancestors';

/**
 * The file browser base command.
 *
 * Override the configName property, and the insertFile method
 *
 * @extends module:core/command~Command
 */
export default class ContentStylesCommand extends Command {
	/**
	 *
	 * @param {Editor} editor
	 * @param {any[]} styleElements
	 */
	constructor( editor, styleElements ) {
		super( editor );
		this.styleElements = styleElements;

		this.value = '';
	}

	/**
	 * Refresh the state of the command.
	 */
	refresh() {
		// Get the first selected block and it's parents.
		const block = first(
			this.editor.model.document.selection.getSelectedBlocks()
		);
		const parents = getAncestors( block );
		parents.reverse();

		// Check for available (and current) styles.
		let value;
		let count = 0;
		for ( const style of this.styleElements ) {
			const parent = parents.find( s => s.name === style.elementName );
			if ( !parent ) {
				style.isHidden = true;
			} else {
				count++;
				style.isHidden = false;
				const classes = this._getClassesFromModel( parent );
				if ( classes === style.classes ) {
					value = style.classes;
				}
			}
		}

		this.isEnabled = !!count;
		this.value = value;
	}

	execute() {
		const model = this.editor.model;
		const document = model.document;
		const blocks = Array.from( document.selection.getSelectedBlocks() );

		model.change( writer => {
			for ( const block of blocks ) {
				writer.setAttribute( 'classes', this.value, block );
			}
		} );
	}

	/**
	 * Provides information whether a decorator with a given name is present in the currently processed selection.
	 *
	 * @private
	 * @param {String} decoratorName The name of the manual decorator used in the model
	 * @returns {Boolean} The information whether a given decorator is currently present in the selection.
	 */
	_getClassesFromModel( element ) {
		// Get the classes off of the element.
		const htmlAttribute = element.getAttribute( 'htmlAttributes' );
		const classesAttribute = element.getAttribute( 'classes' );

		// class = '' is a valid value, class is undefined is not a valid value
		const value =
			classesAttribute === undefined ?
				htmlAttribute && htmlAttribute.classes :
				classesAttribute;

		if ( !value ) {
			return '';
		} else if ( Array.isArray( value ) ) {
			return value.join( ' ' );
		} else {
			return value;
		}
	}
}
